import React from "react";
import ImageGallery from "react-image-gallery";
const photos = [
  {
    original: "./img/gallery/gallery-1.jpg",
    thumbnail: "./img/gallery/gallery-1.jpg",
  },
  {
    original: "./img/gallery/gallery-2.jpg",
    thumbnail: "./img/gallery/gallery-2.jpg",
  },
  {
    original: "./img/gallery/gallery-3.jpg",
    thumbnail: "./img/gallery/gallery-3.jpg",
  },
  {
    original: "./img/gallery/gallery-4.jpg",
    thumbnail: "./img/gallery/gallery-4.jpg",
  },
  {
    original: "./img/gallery/gallery-5.jpg",
    thumbnail: "./img/gallery/gallery-5.jpg",
  },
  {
    original: "./img/gallery/gallery-6.jpg",
    thumbnail: "./img/gallery/gallery-6.jpg",
  },
  {
    original: "./img/gallery/gallery-7.jpg",
    thumbnail: "./img/gallery/gallery-7.jpg",
  },
  {
    original: "./img/gallery/gallery-8.jpg",
    thumbnail: "./img/gallery/gallery-8.jpg",
  },
];
const Gallery = () => {
  return (
    <ImageGallery
      items={photos}
      autoPlay={true}
      showPlayButton={false}
      showFullscreenButton={false}
      showThumbnails={false}
      showNav={false}
      additionalClass="custom-gallery"
    />
  );
};

export default Gallery;
